<template>
  <div class="row">
    <section class="doctor-profile">
      <div class="container">
        <div class="doctor-profile--group">
          <div class="doctor-profile__resume">
            <div class="doctor-profile__intro">
              <img :src="fallbackPhoto()" alt="Imagem de perfil do profissional de saúde" />
              <div class="doctor-profile__infor-doctor">
                <div class="doctor-profile__infor-columns">
                  <h3 class="doctor-profile__name">
                    {{ doctor.name }}
                  </h3>
                  <span class="doctor-profile__price">
                    {{ convertToBrl(doctor.doctor_property.price_cents) }}
                  </span>
                </div>
                <span class="doctor-profile__specialty">
                  {{ doctor.doctor_property.medical_specialty_name }}
                </span>
                <span class="doctor-profile__crm">
                  {{ doctor.doctor_property.council_description }}
                </span>
                <!-- <div class="doctor-profile__rating">
                  <img
                    src="./../assets/images/star-icon.svg"
                    alt="Pontuação do profissional de saúde"
                  />
                  <span class="doctor-profile__number">4.8</span>
                  <span class="doctor-profile__number-comments">
                    (638 Avaliações)
                  </span>
                </div> -->
              </div>
            </div>
            <div class="doctor-profile__more">
              <div class="doctor-profile__list-group">
                <div class="doctor-profile__header">
                  <img src="./../assets/images/specialty-icon.svg" alt="" />
                  <h4 class="doctor-profile__title">Especialidades</h4>
                  <span class="doctor-profile__line" />
                </div>
                <ul class="doctor-profile__list">
                  <li class="doctor-profile__list-item">
                    {{ doctor.doctor_property.medical_specialty_name }}
                  </li>
                </ul>
              </div>

              <div
                class="doctor-profile__text-group"
                v-if="doctor.doctor_property.short_bio"
              >
                <div class="doctor-profile__header">
                  <img src="./../assets/images/about-icon.svg" alt="" />
                  <h4 class="doctor-profile__title">Sobre mim</h4>
                  <span class="doctor-profile__line" />
                </div>
                <div class="doctor-profile__about-resume">
                  <p class="doctor-profile__about-text">
                    {{ doctor.doctor_property.short_bio }}
                  </p>
                </div>
              </div>

              <!-- <div class="doctor-profile__list-group">
                <div class="doctor-profile__header">
                  <img src="./../assets/images/graduation-icon.svg" alt="" />
                  <h4 class="doctor-profile__title">Formação</h4>
                  <span class="doctor-profile__line" />
                </div>
                <ul class="doctor-profile__list">
                  <li class="doctor-profile__list-item">
                    Formado pela USFE em 1987 - CRM 58267.
                  </li>
                  <li class="doctor-profile__list-item">
                    Residência médica em Cirurgia Geral e Cirurgia do Aparelho
                    Digestivo de 1987 à 1989.
                  </li>
                  <li class="doctor-profile__list-item">
                    Residência médica em Ginecologia e Obstetrícia de 1989 à
                    1991.
                  </li>
                  <li class="doctor-profile__list-item">
                    Especialista em Cirurgia de Endometriose.
                  </li>
                  <li class="doctor-profile__list-item">
                    Especialista em Reprodução Humana.
                  </li>
                  <li class="doctor-profile__list-item">
                    Especialista em Cirurgia Íntima.
                  </li>
                </ul>
              </div> -->

              <Testimonial
                v-for="testimonial in doctor.testimonials"
                :key="testimonial.id"
                :testimonial="testimonial"
              />
            </div>
          </div>
          <TimeTable v-if="doctor.id" :doctor="doctor" />
        </div>
      </div>
    </section>
    <BModal
      id="loginOrRegistration"
      ref="loginOrRegistration"
      hide-footer
      hide-header
      centered
      title="Using Component Methods"
    >
      <div class="d-block text-center">
        <h3>Você precisa estar registrado para continuar</h3>
      </div>
      <BButton
        class="mt-3"
        variant="outline-danger"
        block
        @click="loginOrCreate('Login')"
      >
        Logar
      </BButton>
      <BButton
        class="mt-3"
        variant="outline-danger"
        block
        @click="loginOrCreate('Register')"
      >
        Cadastrar
      </BButton>
    </BModal>
  </div>
</template>

<script>
import TimeTable from "./../components/TimeTable";
import Testimonial from "./../components/Testimonial";
import { doctorMethods } from "./../state/helpers";
import { required, minLength, email } from "vuelidate/lib/validators";
import { intToBRL } from "./../utils/currency/convert";

export default {
  name: "DoctorDetail",
  components: { Testimonial, TimeTable },
  data() {
    return {
      doctor: {
        doctor_property: {}
      }
    };
  },
  validations: {
    user: {
      email: { required, email },
      password: { required, minLength: minLength(8) }
    }
  },
  async mounted() {
    await this.getDoctorDetails(this.$route.params.doctor).then(response => {
      this.doctor = response.data;
      this.doctor.doctor_property.council_description = `${this.doctor.doctor_property.council_name} ${this.doctor.doctor_property.council_number} ${this.doctor.doctor_property.council_uf}`;
    });
  },
  methods: {
    ...doctorMethods,
    fallbackPhoto() {
      return this.doctor.photo || require("./../assets/images/doctor-img.jpg");
    },
    loginOrCreate(urlName) {
      this.$router.push({ name: urlName });
    },
    convertToBrl(price) {
      return intToBRL(price);
    }
  }
};
</script>
